// extracted by mini-css-extract-plugin
export default {"logo":"logo--0s5My","util-wrapper":"util-wrapper--5KV+g","utilWrapper":"util-wrapper--5KV+g","util-menu":"util-menu--0lfv1","utilMenu":"util-menu--0lfv1","menu":"menu--0zzqd"};